import Vue from "vue";
import App from "./App.vue";
import router from "./routes/router";
import store from "./stores/store";

import {
  message
} from './plugins/resetMessage';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../element-variables.scss'
import '@/plugins/tableMismatch'

Vue.config.productionTip = false;


Vue.use(ElementUI);


Vue.prototype.$message = message;


import * as echarts from "echarts";
Vue.prototype.echarts = echarts;

// 导入打印
// import Print from 'vue-print-nb'
import Print from './plugins/print'

Vue.use(Print)

Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
